<script>
    import { Router, Route, Link } from "svelte-navigator";
</script>

<main>
    <div class="ui centered grid">
        <div class="doubling ten column row">
            <div class="re column">
                <Link to="/caetgories/whisky">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/whiskey.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">Whiskey</div>
                    </div>
                </Link>
            </div>

            <div class="re column">
                <Link to="/caetgories/red">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/red-wine.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">Red</div>
                    </div>
                </Link>
            </div>

            <div class="re column">
                <Link to="/caetgories/White">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/wite-wine.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">White</div>
                    </div>
                </Link>
            </div>

            <div class="re column">
                <Link to="/caetgories/tequila">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/tequila.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">Tequila</div>
                    </div>
                </Link>
            </div>

            <div class="re column">
                <Link to="/caetgories/scotch">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/scotch.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">Scotch</div>
                    </div>
                </Link>
            </div>

            <div class="re column">
                <Link to="/caetgories/whisky">
                    <div class="" style="padding: 1em;">
                        <div class="imageContainer">
                            <img
                                src="../assets/images/champagne.jpg"
                                alt="logo"
                                height="auto"
                                width="60%"
                            />
                        </div>

                        <div class="bottleText">Champagne</div>
                    </div>
                </Link>
            </div>
        </div>
    </div>
</main>

<style>
    .imageContainer {
        max-height: 20em;
        text-align: center;
    }

    .bottleText {
        text-align: center;
        padding-top: 1em;
        font-size: 15px;
        color: rgb(43, 42, 42);
    }
</style>
